import { Language } from '../models/language';
import { TravelerOperatorConfig } from '../models/traveler-operator-config.model';

export const operatorConfigurations: TravelerOperatorConfig[] = [
  {
    domain: 'default',
    // All operators except Stegra, Tornion Junabussi and Baltic Gateway
    operators: [
      '1124',
      '1156',
      '1285',
      '1120',
      '1283',
      '1284',
      '1126',
      '1288',
      '1317',
      '1394',
      '1450',
      '1477',
      '1531',
      '1652',
      '1684',
      '1726',
      '1756',
      '1791',
      '1806',
      '1813',
      '1814',
      '1848',
      '1900',
      '1901',
      '2001',
      '2002',
      '2003',
      '2004',
      '2005',
    ],
    primaryColor: '#125428',
    tripLineColor: '#125428',
    secondaryColor: '#006F32',
    headerTextColor: '#ffffff',
    selectedStopColor: '#125428',
    logo: 'assets/logos/default.png',
    logoWidth: 34,
    swedishTitle: 'Ersättningstrafik',
    norwegianTitle: 'Buss for tog',
    danishTitle: 'Erstatningstrafik',
    finnishTitle: 'Korvaava liikenne',
    englishTitle: 'Replacement traffic',
    fallbackTitle: 'Ersättningstrafik',
    defaultLanguage: Language.SV,
  },
  {
    domain: 'sl',
    operators: ['1124', '1126', '1806', '1900', '1901', '2002'],
    primaryColor: '#2870F0',
    tripLineColor: '#2870F0',
    secondaryColor: '#12151A',
    headerTextColor: '#FFFFFF',
    selectedStopColor: '#2870F0',
    logo: 'assets/logos/sl.png',
    logoWidth: 50,
    swedishTitle: 'Ersättningstrafik',
    norwegianTitle: 'Buss for tog',
    danishTitle: 'Erstatningstrafik',
    finnishTitle: 'Korvaava liikenne',
    englishTitle: 'Replacement traffic',
    fallbackTitle: 'Ersättningstrafik',
    defaultLanguage: Language.SV,
  },
  {
    domain: 'oresundstag',
    operators: ['1477', '1450', '1726', '2003'],
    primaryColor: '#D72B14',
    tripLineColor: '#D72B14',
    secondaryColor: '#000000',
    headerTextColor: '#FFFFFF',
    selectedStopColor: '#D72B14',
    logo: 'assets/logos/oresundstag.png',
    logoWidth: 120,
    swedishTitle: 'Ersättningstrafik',
    norwegianTitle: 'Buss for tog',
    danishTitle: 'Erstatningstrafik',
    finnishTitle: 'Korvaava liikenne',
    englishTitle: 'Replacement traffic',
    fallbackTitle: 'Ersättningstrafik',
    defaultLanguage: Language.SV,
  },
  {
    domain: 'varmlandstrafik',
    operators: ['1284'],
    primaryColor: '#F9B001',
    tripLineColor: '#F9B001',
    secondaryColor: '#5A5757',
    headerTextColor: '#000000',
    selectedStopColor: '#F9B001',
    logo: 'assets/logos/varmlandstrafik.png',
    logoWidth: 44,
    swedishTitle: 'Ersättningstrafik',
    norwegianTitle: 'Buss for tog',
    danishTitle: 'Erstatningstrafik',
    finnishTitle: 'Korvaava liikenne',
    englishTitle: 'Replacement traffic',
    fallbackTitle: 'Ersättningstrafik',
    defaultLanguage: Language.SV,
  },
  {
    domain: 'sjnord',
    operators: ['1394'],
    primaryColor: '#2E364A',
    tripLineColor: '#2E364A',
    secondaryColor: '#D42239',
    headerTextColor: '#FFFFFF',
    selectedStopColor: '#2E364A',
    logo: 'assets/logos/sjnord.png',
    logoWidth: 120,
    swedishTitle: 'Ersättningstrafik',
    norwegianTitle: 'Buss for tog',
    danishTitle: 'Erstatningstrafik',
    finnishTitle: 'Korvaava liikenne',
    englishTitle: 'Replacement traffic',
    fallbackTitle: 'Buss for tog',
    defaultLanguage: Language.NB,
  },
  {
    domain: 'ga',
    operators: ['1317'],
    primaryColor: '#353649',
    tripLineColor: '#353649',
    secondaryColor: '#46485A',
    headerTextColor: '#FFFFFF',
    selectedStopColor: '#353649',
    logo: 'assets/logos/ga.png',
    logoWidth: 86,
    swedishTitle: 'Ersättningstrafik',
    norwegianTitle: 'Buss for tog',
    danishTitle: 'Erstatningstrafik',
    finnishTitle: 'Korvaava liikenne',
    englishTitle: 'Replacement traffic',
    fallbackTitle: 'Buss for tog',
    defaultLanguage: Language.NB,
  },
  {
    domain: 'vy',
    operators: ['1156', '1285', '1120', '1283', '1284', '1531'],
    primaryColor: '#019577',
    tripLineColor: '#019577',
    secondaryColor: '#00453E',
    headerTextColor: '#ffffff',
    selectedStopColor: '#019577',
    logo: 'assets/logos/vy2.png',
    logoWidth: 70,
    swedishTitle: 'Ersättningstrafik',
    norwegianTitle: 'Buss for tog',
    danishTitle: 'Erstatningstrafik',
    finnishTitle: 'Korvaava liikenne',
    englishTitle: 'Replacement traffic',
    fallbackTitle: 'Ersättningstrafik',
    defaultLanguage: Language.SV,
  },
  {
    domain: 'norrtag',
    operators: ['1120', '2001'],
    primaryColor: '#011C48',
    tripLineColor: '#011C48',
    secondaryColor: '#004D9C',
    headerTextColor: '#FFFFFF',
    selectedStopColor: '#011C48',
    logo: 'assets/logos/norrtag2.png',
    logoWidth: 120,
    swedishTitle: 'Ersättningstrafik',
    norwegianTitle: 'Buss for tog',
    danishTitle: 'Erstatningstrafik',
    finnishTitle: 'Korvaava liikenne',
    englishTitle: 'Replacement traffic',
    fallbackTitle: 'Ersättningstrafik',
    defaultLanguage: Language.SV,
  },
  {
    domain: 'vr',
    operators: ['1288', '1813'],
    primaryColor: '#333333',
    tripLineColor: '#333333',
    secondaryColor: '#14B250',
    headerTextColor: '#FFFFFF',
    selectedStopColor: '#333333',
    logo: 'assets/logos/vr.png',
    logoWidth: 50,
    swedishTitle: 'Ersättningstrafik',
    norwegianTitle: 'Buss for tog',
    danishTitle: 'Erstatningstrafik',
    finnishTitle: 'Korvaava liikenne',
    englishTitle: 'Replacement traffic',
    fallbackTitle: 'Ersättningstrafik',
    defaultLanguage: Language.SV,
  },
  {
    domain: 'event',
    operators: ['1756'],
    primaryColor: '#125428',
    tripLineColor: '#125428',
    secondaryColor: '#006F32',
    headerTextColor: '#FFFFFF',
    selectedStopColor: '#125428',
    logo: 'assets/logos/nobina.png',
    logoWidth: 86,
    swedishTitle: 'Event-bussar',
    norwegianTitle: 'Event-busser',
    danishTitle: 'Event-busser',
    finnishTitle: 'Tapahtumabussit',
    englishTitle: 'Event buses',
    fallbackTitle: 'Event-bussar',
    defaultLanguage: Language.SV,
    showReason: false,
    showRoute: false,
    showTrainNumber: false,
    showSiteInfo: false,
  },
  {
    domain: 'metro',
    operators: ['1814'],
    primaryColor: '#14143C',
    tripLineColor: '#14143C',
    secondaryColor: '#8B0A03',
    headerTextColor: '#FFFFFF',
    selectedStopColor: '#14143C',
    logo: 'assets/logos/metro.png',
    logoWidth: 50,
    swedishTitle: '',
    norwegianTitle: '',
    danishTitle: '',
    finnishTitle: '',
    englishTitle: '',
    fallbackTitle: 'Metrobus',
    defaultLanguage: Language.DK,
  },
  {
    domain: 'stegra',
    operators: ['1834'],
    primaryColor: '#151515',
    tripLineColor: '#151515',
    secondaryColor: '#D278FF',
    headerTextColor: '#FFFFFF',
    selectedStopColor: '#151515',
    logo: 'assets/logos/stegra.png',
    logoWidth: 120,
    swedishTitle: '',
    norwegianTitle: '',
    danishTitle: '',
    finnishTitle: '',
    englishTitle: '',
    fallbackTitle: 'Transportation',
    defaultLanguage: Language.SV,
    showReason: false,
    showTrainNumber: false,
  },
  {
    domain: 'hedefashionoutlet',
    operators: ['2000'],
    primaryColor: '#ec6338',
    tripLineColor: '#ec6338',
    secondaryColor: '#ee7294',
    headerTextColor: '#ffffff',
    selectedStopColor: '#ec6338',
    logo: 'assets/logos/hedefashionoutlet.png',
    logoWidth: 120,
    swedishTitle: 'Shoppingbuss',
    norwegianTitle: '',
    danishTitle: '',
    finnishTitle: '',
    englishTitle: '',
    fallbackTitle: 'Shopping bus',
    defaultLanguage: Language.SV,
  },
  {
    domain: 'junabussi',
    operators: ['2006'],
    primaryColor: '#125428',
    tripLineColor: '#125428',
    secondaryColor: '#006F32',
    headerTextColor: '#ffffff',
    selectedStopColor: '#125428',
    logo: 'assets/logos/nobina.png',
    logoWidth: 86,
    swedishTitle: 'Torneå Tågbuss',
    norwegianTitle: '',
    danishTitle: '',
    finnishTitle: 'Tornion Junabussi',
    englishTitle: 'Tornio Trainbus',
    fallbackTitle: 'Tornion Junabussi',
    defaultLanguage: Language.FI,
  },
  {
    domain: 'baltic',
    operators: ['2008'],
    primaryColor: '#004185',
    tripLineColor: '#004185',
    secondaryColor: '#12151A',
    headerTextColor: '#ffffff',
    selectedStopColor: '#004185',
    logo: 'assets/logos/balticgateway.png',
    logoWidth: 120,
    swedishTitle: 'Bus service',
    norwegianTitle: '',
    danishTitle: '',
    finnishTitle: 'Bus service',
    englishTitle: 'Bus service',
    fallbackTitle: 'Bus service',
    defaultLanguage: Language.EN,
  },
  {
    domain: 'lynra',
    operators: ['2009'],
    primaryColor: '#F6F4F4',
    tripLineColor: '#242428',
    secondaryColor: '#FF4D4F',
    headerTextColor: '#242428',
    selectedStopColor: '#242428',
    logo: 'assets/logos/lynra.png',
    logoWidth: 80,
    favIcon: 'assets/logos/Lynra_square_transparent.png',
    swedishTitle: 'Shuttle Service',
    norwegianTitle: '',
    danishTitle: '',
    finnishTitle: 'Shuttle Service',
    englishTitle: 'Shuttle Service',
    fallbackTitle: 'Shuttle Service',
    defaultLanguage: Language.EN,
    showReason: false,
    showTrainNumber: false,
  },
  {
    domain: 'snalltaget',
    operators: ['2010'],
    primaryColor: '#FBFBFB',
    tripLineColor: '#F12E20',
    secondaryColor: '#F12E20',
    headerTextColor: '#3A3A3A',
    selectedStopColor: '#F12E20',
    logo: 'assets/logos/snalltaget.png',
    logoWidth: 120,
    swedishTitle: 'Replacement bus',
    norwegianTitle: '',
    danishTitle: '',
    finnishTitle: 'Replacement bus',
    englishTitle: 'Replacement bus',
    fallbackTitle: 'Replacement bus',
    defaultLanguage: Language.EN,
  },
  {
    domain: 'sj',
    operators: ['2011'],
    primaryColor: '#009D36',
    tripLineColor: '#009D36',
    secondaryColor: '#949494',
    headerTextColor: '#FFFFFF',
    selectedStopColor: '#949494',
    logo: 'assets/logos/sj_logo_white.png',
    favIcon: 'assets/logos/favicon_sj.png',
    logoWidth: 50,
    swedishTitle: 'Ersättningstrafik',
    norwegianTitle: 'Buss for tog',
    danishTitle: 'Erstatningstrafik',
    finnishTitle: 'Korvaava liikenne',
    englishTitle: 'Replacement traffic',
    fallbackTitle: 'Ersättningstrafik',
    defaultLanguage: Language.SV,
  },
  {
    domain: 'sjvanertag',
    operators: ['2012'],
    primaryColor: '#009D36',
    tripLineColor: '#009D36',
    secondaryColor: '#949494',
    headerTextColor: '#FFFFFF',
    selectedStopColor: '#949494',
    logo: 'assets/logos/sj_logo_white.png',
    favIcon: 'assets/logos/favicon_sj.png',
    logoWidth: 50,
    swedishTitle: 'Ersättningstrafik',
    norwegianTitle: 'Buss for tog',
    danishTitle: 'Erstatningstrafik',
    finnishTitle: 'Korvaava liikenne',
    englishTitle: 'Replacement traffic',
    fallbackTitle: 'Ersättningstrafik',
    defaultLanguage: Language.SV,
  },
];
